import { render, staticRenderFns } from "./ToolBox.vue?vue&type=template&id=648f7a91&scoped=true"
import script from "./ToolBox.vue?vue&type=script&lang=js"
export * from "./ToolBox.vue?vue&type=script&lang=js"
import style0 from "./ToolBox.vue?vue&type=style&index=0&id=648f7a91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648f7a91",
  null
  
)

export default component.exports